import {Component, Element, Prop} from '@stencil/core';
import '@orestbida/iframemanager';
import * as CookieConsent from 'vanilla-cookieconsent';

declare var iframemanager: any;

@Component({
    tag: 'physiogroup-iframe',
    styleUrl: 'physiogroup-iframe.scss',
})
export class PhysiogroupIframe {
    @Prop() public currentLanguage: string = 'de';
    @Element() text: HTMLElement;

    componentDidLoad() {
        if ((window as any).im) {
            return;
        }

        const languages = {
            de: {
                notice: this.text.innerHTML,
                loadBtn: 'Inhalt laden',
                loadAllBtn: "Nicht erneut fragen"
            },
            en: {
                notice: this.text.innerHTML,
                loadBtn: 'Load Content',
                loadAllBtn: "Don't ask again"
            }
        };

        const im = iframemanager();
        (window as any).im = im;
        (window as any).im.run({
            currLang: this.currentLanguage,
            autoLang: false,

            onChange: ({eventSource}) => {
                if (eventSource.action === 'accept') {
                    const servicesToAccept = [
                        ...CookieConsent.getUserPreferences().acceptedCategories,
                        'external'
                    ];

                    CookieConsent.acceptCategory(servicesToAccept);
                }

                if (eventSource.action === 'reject') {
                    const categoriesToAccept = CookieConsent.getUserPreferences().acceptedCategories;

                    CookieConsent.acceptCategory(categoriesToAccept, ['external']);
                }
            },

            services: {
                iframe: {
                    embedUrl: '{data-id}',
                    loading: 'lazy',
                    iframe: {
                        allow: 'fullscreen',
                    },
                    languages,
                    onReject: (_iframe, serviceDiv) => {
                        serviceDiv.querySelector('iframe').remove();
                        window.location.reload();
                    },
                },

                video: {
                    onAccept: async () => {
                    },
                    onReject: (_iframe, serviceDiv) => {
                        serviceDiv.querySelector('voan-field-video-image').remove();
                        window.location.reload();
                    },
                    languages,
                },

                googlemapsapi: {
                    embedUrl: '{data-id}',
                    loading: 'lazy',
                    onAccept: async (div) => {
                        const map = div.querySelector('voan-map');
                        map.loaded = true;
                    },
                    onReject: (_iframe, serviceDiv) => {
                        serviceDiv.querySelector('voan-map').remove();
                        window.location.reload();
                    },
                    languages,
                },
            }
        });
    }
}
